/* Victorieboontje redesign — mobiel menu (native dialog) en aantal in winkelmand-icoon. */
(function () {
  if (window.__vbChrome) return; window.__vbChrome = true;

  function initMenu() {
    var dialog = document.querySelector('[data-vb-menu]');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    var opener = document.querySelector('[data-vb-menu-open]');
    function close() { dialog.close(); }
    if (opener) opener.addEventListener('click', function () {
      dialog.showModal();
      opener.setAttribute('aria-expanded', 'true');
    });
    dialog.addEventListener('close', function () { if (opener) { opener.setAttribute('aria-expanded', 'false'); opener.focus(); } });
    dialog.addEventListener('click', function (e) { if (e.target === dialog || e.target.closest('[data-vb-menu-close]')) close(); });
    window.matchMedia('(min-width: 990px)').addEventListener('change', function (e) { if (e.matches && dialog.open) close(); });
  }

  function setCount(n) {
    document.querySelectorAll('[data-vb-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = !(n > 0); });
    document.querySelectorAll('[data-vb-cart-label]').forEach(function (el) {
      el.setAttribute('aria-label', n > 0 ? 'Winkelmand, ' + n + ' artikelen' : 'Winkelmand');
    });
  }

  function initCart() {
    // Whisk zet na toevoegen de oude icoon-opmaak in #cart-icon-bubble (bij ons een inerte <template>); lees daar het aantal uit.
    var source = document.querySelector('[data-vb-cart-source]');
    if (source && source.content) {
      new MutationObserver(function () {
        var el = source.content.querySelector('.site-header__cart-count [aria-hidden]');
        setCount(el ? parseInt(el.textContent, 10) || 0 : 0);
      }).observe(source.content, { childList: true, subtree: true, characterData: true });
    }
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (e) { if (e && e.cartData && typeof e.cartData.item_count === 'number') setCount(e.cartData.item_count); });
    }
  }

  // Melding "nog € X tot gratis verzending" bovenin het Whisk-winkelmanddrawer (Figma 38:323).
  function fmt(c, f) {
    var p = (c / 100).toFixed(2).split('.'), t = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return (f || '€{{amount_with_comma_separator}}').replace(/\{\{\s*\w+\s*\}\}/, t + ',' + p[1]);
  }
  function initShipping() {
    var h = document.querySelector('[data-vb-header]'), drawer = document.getElementById('cart-drawer');
    var limit = h ? parseInt(h.dataset.freeShip, 10) : 0;
    if (!drawer || !limit) return;
    var box = document.createElement('p'); box.className = 'vb-cart-ship'; box.setAttribute('aria-live', 'polite');
    var head = drawer.querySelector('.drawer__header'); if (head) head.insertAdjacentElement('afterend', box);
    function show(total) {
      var rest = limit - total;
      box.hidden = total === 0;
      box.textContent = rest > 0 ? 'Nog ' + fmt(rest, h.dataset.money) + ' tot gratis verzending (vanaf ' + fmt(limit, h.dataset.money).replace(',00', '') + ')' : 'Je bestelling wordt gratis verzonden';
    }
    show(parseInt(h.dataset.cartTotal, 10) || 0);
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (e) {
        if (e && e.cartData && typeof e.cartData.total_price === 'number') show(e.cartData.total_price);
        else fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { show(c.total_price); });
      });
    }
  }

  function init() { initMenu(); initCart(); initShipping(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
